import React, { MouseEventHandler } from 'react';
import { Link } from './Link';

export type HeaderLinkProps = {
  actionId: string;
  to: string;
  target?: string;
  className?: string;
  onClick?: MouseEventHandler<any>;
};

export const HeaderLink: React.FC<HeaderLinkProps> = ({ children, to, actionId, target, className, onClick }) => (
  <Link to={to} actionId={actionId} target={target} className={className} onClick={onClick}>
    {children}
  </Link>
);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/links/HeaderLink.tsx